import { useState, useEffect } from 'react'
import { images, signUpImages } from '../../services/images.service'
import { signup, loginWithGoogle } from '../../store/slices/user.slice'
import { useNavigate } from 'react-router-dom'
import { isValidUsername } from '../../services/util.service'
import { toast } from 'react-hot-toast'
import { useDispatch } from 'react-redux'
import { Button } from '../../cmps/ui/elements'

export function SignUp({ onClose }) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [showPassword, setShowPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const [userCred, setUserCred] = useState({
    nickname: '',
    email: '',
    password: '',
    username: '',
  })

  const [isInvalidUsername, setIsInvalidUsername] = useState(false)

  useEffect(() => {
    const cleanUsername = userCred.username.toLowerCase().trim()
    setIsInvalidUsername(!isValidUsername(cleanUsername))
  }, [userCred.username])

  function togglePasswordVisibility() {
    setShowPassword((prev) => !prev)
  }

  function handleChange({ target }) {
    const { name, value } = target
    setUserCred({ ...userCred, [name]: value })
  }

  async function onSignup(ev) {
    ev.preventDefault()
    const cleanUsername = userCred.username.toLowerCase().trim()

    if (!isValidUsername(cleanUsername)) {
      toast.error(
        'שם המשתמש חייב להכיל לפחות 3 אותיות באנגלית קטנה, ויכול לכלול גם מספרים או _'
      )
      return
    }

    setIsLoading(true)
    try {
      await dispatch(signup({ ...userCred, username: cleanUsername })).unwrap()

      if (onClose) onClose() // 🚀 סוגר את הפופאפ אחרי הרשמה מוצלחת
      navigate('/') // ואז מנווט אם צריך
    } catch (err) {
      // השגיאה כבר טופלה בקונטרולר
    } finally {
      setIsLoading(false)
    }
  }

  async function onGoogleSignup() {
    setIsLoading(true)
    try {
      await dispatch(loginWithGoogle()).unwrap()
      // navigate('/')
    } catch (err) {
      // השגיאה כבר טופלה בקונטרולר
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <section className="flex flex-col items-center">
      <div
        className="w-full flex flex-col bg-secondaryBackground items-center max-w-[450px] max-h-[750px] rounded-lg shadow-lg p-6"
        style={{
          border: '2px solid transparent',
          borderImage: `url(${images.redBorder}) 20 stretch`,
        }}
      >
        <button
          className="self-end mb-4"
          onClick={onClose ? onClose : () => navigate(-1)}
        >
          <img src={images.closeMenu} alt="Close Menu" className="w-10 h-10" />
        </button>

        <div className="text-center mb-6">
          <h1 className="text-2xl text-softText mb-2">הרשמה לאניזון</h1>
          <h2 className="text-sm text-muted">
            צור רשימת צפייה, הוסף כותב מועדף או תהנה מתוכן שרלוונטי אליך
          </h2>
        </div>

        <form className="flex flex-col gap-6 w-full" onSubmit={onSignup}>
          {/* שם משתמש */}
          <div className="flex flex-col relative">
            <input
              id="username"
              name="username"
              type="text"
              placeholder="שם משתמש (לדוגמה: anime_lover)"
              value={userCred.username}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 focus:border border-primary bg-secondary text-Text placeholder-secondaryText focus:outline-none focus:ring-2 focus:ring-accent"
              disabled={isLoading}
            />
            <div className="text-xs text-muted mt-1">
              💡 שם המשתמש לא יוצג באתר – רק בכתובת ה־URL שלך
              <br />
              לדוגמה:{' '}
              <span className="text-softText">
                anizone.co.il/user/anime_lover
              </span>
            </div>
            {isInvalidUsername && (
              <div className="text-red-400 text-xs mt-1">
                שם המשתמש חייב לכלול לפחות 3 אותיות באנגלית קטנה, ואפשר גם
                מספרים או קו תחתון (_)
              </div>
            )}
          </div>

          
          {/* אימייל */}
          <div className="flex flex-col">
            <input
              id="email"
              name="email"
              type="email"
              placeholder="אימייל"
              value={userCred.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 focus:border border-primary bg-secondary text-Text placeholder-secondaryText focus:outline-none focus:ring-2 focus:ring-accent"
              disabled={isLoading}
            />
          </div>

          {/* כינוי */}
          <div className="flex flex-col">
            <input
              id="nickname"
              name="nickname"
              type="text"
              placeholder="כינוי"
              value={userCred.nickname}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 focus:border border-primary bg-secondary text-Text placeholder-secondaryText focus:outline-none focus:ring-2 focus:ring-accent"
              disabled={isLoading}
            />
          </div>

          {/* סיסמה */}
          <div className="flex flex-col relative">
            <input
              id="password"
              name="password"
              type={showPassword ? 'text' : 'password'}
              placeholder="סיסמה"
              value={userCred.password}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 focus:border border-primary bg-secondary text-Text placeholder-secondaryText focus:outline-none focus:ring-2 focus:ring-accent"
              disabled={isLoading}
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="absolute top-1/3 left-2"
              disabled={isLoading}
            >
              <img
                src={
                  showPassword
                    ? signUpImages.passwordShow
                    : signUpImages.passwordHide
                }
                alt="Toggle Password Visibility"
                className="w-5 h-5"
              />
            </button>
          </div>


          {/* כפתור הרשמה */}
          <Button
            text={isLoading ? 'טוען...' : 'הרשמה לאתר'}
            width={380}
            height={60}
            fontSize="text-md"
            textColor="text-white"
            bgColor="fill-primary"
            hoverBgColor="hover:fill-primaryDark"
            type="submit"
            disabled={isLoading || isInvalidUsername}
          />
        </form>

        

        <span className="text-xs text-muted mt-4">
          בהרשמתך לאתר, הינך מצהיר שקראת, הבנת והסכמת{' '}
          <a href="/terms-of-use" target="_blank" className="underline">
            לתנאי השימוש
          </a>
        </span>

        <img className="m-4 w-full" src={signUpImages.divider} alt="Divider" />

        <div className="flex justify-center w-full">
          <button
            onClick={onGoogleSignup}
            className="flex items-center justify-center w-full gap-3 px-4 py-2 bg-[#3A3A3A] hover:scale-105 transition-transform"
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="text-primaryText">טוען...</span>
            ) : (
              <>
                <img
                  src={signUpImages.googleIcon}
                  alt="Google sign up"
                  className="w-6 h-6"
                />
                <span className="text-primaryText">הרשמה עם גוגל</span>
              </>
            )}
          </button>
        </div>
      </div>
    </section>
  )
}
